import { render, staticRenderFns } from "./BreakdownPage.vue?vue&type=template&id=442e9432&scoped=true&"
import script from "./BreakdownPage.vue?vue&type=script&lang=js&"
export * from "./BreakdownPage.vue?vue&type=script&lang=js&"
import style0 from "./BreakdownPage.vue?vue&type=style&index=0&id=442e9432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e9432",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
